<template>
    <div :class="{ 'validation-padding': !removeValidationPadding }">
        <transition @before-enter="beforeEnter" @enter="enter" @leave="leave">
            <div
                key="error"
                class="con-text-validation span-text-validation-danger vs-input--text-validation-span"
            >
                <span class="span-text-validation">
                    {{ errorText }}
                </span>
            </div>
        </transition>
    </div>
</template>

<script>
/* 
    This component is designed specifically to be used by components importing the 
    validation mixins. If you are not importing this in the parent component, it will not work.
*/

export default {
    name: 'vx-validation-message',
    computed: {
        parent() {
            return this.$parent
        },
        removeValidationPadding() {
            return this.parent.removeValidationPadding
        },
        errorText() {
            return this.parent.errorText
        }
    },
    methods: {
        beforeEnter(el) {
            el.style.height = 0
        },
        enter(el, done) {
            let h = el.scrollHeight
            el.style.height = h + 'px'
            done()
        },
        leave: function (el) {
            el.style.height = 0 + 'px'
        }
    }
}
</script>
